import React from "react";

import { PromptWrapper, PromptContent } from "./style";


interface Props {
  children: React.ReactNode;
}

export default function Prompt({
  children,
}: Props) {
  return (
    <PromptWrapper>
      <PromptContent>
        {children}
      </PromptContent>
    </PromptWrapper>
  );
}
